import { usePropertyIsAcquisitionFinancing } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface AcquisitionFinancingProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
    labelSize?: ToggleButtonLabelSize;
}

export const AcquisitionFinancing: React.FC<AcquisitionFinancingProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
    labelSize = ToggleButtonLabelSize.Medium,
}) => {
    const label = 'Is acquisition funding required at closing?';
    const [isAcquisitionFinancing, set_isAcquisitionFinancing] = usePropertyIsAcquisitionFinancing(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_isAcquisitionFinancing(true);
                return;
            case 'no':
                set_isAcquisitionFinancing(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={isAcquisitionFinancing ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonIsAcquisitionFinancing'
                    value={isAcquisitionFinancing}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='This field is required.'
                    label={label}
                    labelSize={labelSize}
                />
            )}
        </>
    );
};
